export default __webpack_public_path__ + "static/media/8.12.8a914566.mp3";